
    import __i18nConfig from '@next-translate-root/i18n.json'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import type { GetStaticProps } from 'next';
import { getStylesHubProps, type StylesHubProps, } from '@/components/style-guides/server';
import StylesHubPage from '@/components/style-guides/StylesHubPage';
export default function InteriorDesignStylesPage(props: StylesHubProps) {
    return <StylesHubPage {...props}/>;
}
// English only: other languages redirect here (next.config.mjs).
const getStaticProps: GetStaticProps<StylesHubProps> = async ({ locale, }) => locale && locale !== 'en'
    ? { notFound: true }
    : { props: getStylesHubProps() };

    async function __Next_Translate__getStaticProps__1a1296daacd__(ctx) {
      if (typeof global !== 'undefined') {
        global.i18nConfig = __i18nConfig
      }
      const res = await getStaticProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/interior-design-styles/index',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import('../../../locales/' + l + '/' + n).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1a1296daacd__ as getStaticProps }
  